import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { modalStyle, modalContentStyle, changeModalStyle, spendModalStyle, changeModalContentStyle, path } from 'Constants'

import Modal from 'reboron/OutlineModal'
import Button from 'UI/Button'
import TabContainer from './TabContainer';
import { AppBar } from '@material-ui/core';
import {
    pendingChanges,
    saveKPIOnRedirect,
    deleteIntermediateKPIOnRedirect,
    isEnablementStrategyContainerPage,
    isSpendParameterPage,
    saveSpendParametersOnRedirect,
    isWaveRecalcOnSpendParamRedirect,
    //isSavingTabVisible
} from 'actions/spendActions'
import { connect } from 'react-redux'
import {
    setSubTabMenu,
    setTabMenu,
    setIsLastSubTab
} from 'actions/userActions'

import {
    saveValueStoryOnRedirect,
    isValueStoryPage
} from 'actions/discoveryActions'

const alertModalStyle = Object.assign({}, changeModalStyle);
alertModalStyle.zIndex = '1060';
alertModalStyle.width = '50%';

const alertModalStyleSpendParameter = Object.assign({}, spendModalStyle);
alertModalStyleSpendParameter.zIndex = '1060';
alertModalStyleSpendParameter.width = '85%';

const styles = theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        borderBottom: "1px solid grey",
        boxShadow: "none"
    },
    indicator: {
        backgroundColor: "#008fd3",
    },
    textColor: {
        // color: "#008fd3",
    },
    paddingTop: {
        //    paddingTop: "20px"
    },
    tabs: {
        borderLeft: "1px solid grey",
        borderRight: "1px solid grey",
        padding: "10px"
    },
    borderBothSides: {
        borderLeft: "1px solid grey",
        borderRight: "1px solid grey",
    },
    borderLeftSide: {
        borderLeft: "1px solid grey",
    }
});

class SpendTabPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: props.tabId,
            toggle: false,
            nextTab: 5,
            event: null,
            activeTabCopy: props.tabId,
            isLoading: false,
        };
        this.showModal = this.showModal.bind(this)
        this.hideModal = this.hideModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.continueValueStoryNavigation = this.continueValueStoryNavigation.bind(this)
    }

    showModal(action) {
        this.refs[action].show()
    }

    hideModal(action) {
        this.refs[action].hide()
    }

    closeModal(action) {
        let activeTab = this.state.activeTabCopy
        this.props.pendingChanges(null);
        if (this.props.isEnablementStrategyContainerPage)
            this.props.isEnablementStrategyContainerPage(false);
        if (this.props.isValueStoryPage)
            this.props.isValueStoryPage(false);
        if (this.props.isSpendParameterPage)
            this.props.isSpendParameterPage(false);

        this.setState({ toggle: false, activeTab: activeTab }, this.refs[action].hide())
        if (this.props.dispatchTabChange) {
            if (this.props.handleNextButton) {
                this.props.handleNextButton(activeTab)
            }
            this.props.dispatchTabChange(activeTab)

        }
    }

    continueKPINavigation(action, isIntermediateDataDelete) {
        this.setState({ isLoading: true });
        if (isIntermediateDataDelete)
            this.props.deleteIntermediateKPIOnRedirect(true);
        else
            this.props.saveKPIOnRedirect(true);
        setTimeout(() => {
            this.props.isEnablementStrategyContainerPage(false);
            this.closeModal(action);
            this.setState({ isLoading: false });
        }, 10000);
    }

    continueValueStoryNavigation(action) {
        this.setState({ isLoading: true });
        this.props.saveValueStoryOnRedirect(true);
        setTimeout(function () {
            if (this.props.user.error == "" || this.props.user.error == null) {
                this.props.isValueStoryPage(false);
                this.continueNavigation(action);
                this.setState({ isLoading: false });
            }
            else {
                this.setState({ isLoading: false });
            }
        }.bind(this), 4000);
    }

    continueSpendParameterNavigation(action) {
        this.setState({ isLoading: true });
        this.props.saveSpendParametersOnRedirect(true);
        this.props.isWaveRecalcOnSpendParamRedirect(false);
        setTimeout(() => {
            this.props.isSpendParameterPage(false);
            this.props.saveSpendParametersOnRedirect(false);
            this.continueNavigation(action);
            this.setState({ isLoading: false });
        }, 6000);
    }
    continueSpendParameterNavigationWithWaveRecalc(action) {
        this.setState({ isLoading: true });
        this.props.saveSpendParametersOnRedirect(true);
        this.props.isWaveRecalcOnSpendParamRedirect(true);
        setTimeout(() => {
            this.props.isSpendParameterPage(false);
            this.props.saveSpendParametersOnRedirect(false);
            this.continueNavigation(action);
            this.setState({ isLoading: false });
        }, 6000);
    }

    continueNavigation(action) {
        let activeTab = this.state.activeTabCopy
        this.props.pendingChanges(null)
        if(action == 'SpendParameter')
            this.props.spendDetails.currentActiveRequest = Object.assign({}, this.props.spendDetails.oldActiveRequest);
            
        this.setState({ toggle: false, activeTab: activeTab }, this.refs[action].hide())
        if (this.props.dispatchTabChange) {
            if (this.props.handleNextButton) {
                this.props.handleNextButton(activeTab)
            }
            this.props.dispatchTabChange(activeTab)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.change == null || nextProps.change == false) {
            this.setState({ toggle: false })
        }
        else if (nextProps.change == true) {
            this.setState({ toggle: true })
        }
    }

    componentDidUpdate(prevProps) {
        // Log changes for debugging
        if (prevProps.isSavingTabVisible !== this.props.isSavingTabVisible) {
            console.log("isSavingTabVisible changed:", this.props.isSavingTabVisible);
        }

        // If isSavingTabVisible or tabs changed, ensure activeTab remains valid
        if (prevProps.isSavingTabVisible !== this.props.isSavingTabVisible || prevProps.tabs !== this.props.tabs) {
            const tabOrder = [1, 5, 9, 4, 11, 12, 6, 2, 3, 7, 8, 10];
            const c = tabOrder.reduce(function (r, a, i) {
                r[a] = i;
                return r;
            }, {});

            let visibleTabs = Array.isArray(this.props.tabs) ? [...this.props.tabs] : [];

            if (this.props.isSavingTabVisible === 'No') {
                visibleTabs = visibleTabs.filter(tab => (tab.label || '').toLowerCase() !== 'saving');
            }

            visibleTabs.sort(function (x, y) {
                return (c[x.id] || 0) - (c[y.id] || 0);
            });

            const visibleIds = visibleTabs.map(t => t.id);

            if (visibleIds.length > 0 && visibleIds.indexOf(this.state.activeTab) === -1) {
                // Current active tab is not visible anymore. Switch to first visible tab.
                const newActive = visibleIds[0];
                this.setState({ activeTab: newActive }, () => {
                    if (this.props.dispatchTabChange) {
                        this.props.dispatchTabChange(newActive);
                    }
                });
            }
        }
    }

    handleChange = (event, activeTab) => {
        this.props.setTabMenu(activeTab);
        this.props.setSubTabMenu(1);
        if (activeTab == 4 || activeTab == 3 || activeTab == 7 || activeTab == 10 || activeTab == 12)
            this.props.setIsLastSubTab(true);
        else
            this.props.setIsLastSubTab(false);

        if (this.props.spendDetails !== undefined && this.props.spendDetails.isLoading === false && this.props.spendDetails.isBlank === false
            && this.props.change !== undefined && this.props.change !== null
            && this.props.change === true
            && this.props.spendDetails.isKpiStrategy !== undefined && this.props.spendDetails.isKpiStrategy !== null
            && this.props.spendDetails.isKpiStrategy === true) {
            this.setState({ activeTabCopy: activeTab }, this.showModal("KPI"));
        }
        else if (this.props.change !== undefined && this.props.change !== null
            && this.props.change === true &&
            this.props.valueStory.isValueStoryPage !== undefined && this.props.valueStory.isValueStoryPage !== null
            && this.props.valueStory.isValueStoryPage === true) {
            this.setState({ activeTabCopy: activeTab }, this.showModal("VS"));
        }
        else if (this.props.change !== undefined && this.props.change !== null
            && this.props.change === true &&
            this.props.spendDetails.isSpendParameterPage !== undefined && this.props.spendDetails.isSpendParameterPage !== null
            && this.props.spendDetails.isSpendParameterPage === true) {
            this.setState({ activeTabCopy: activeTab }, this.showModal("SpendParameter"));
        }
        else if (this.props.spendDetails !== undefined && this.props.spendDetails.isLoading === false && this.props.spendDetails.isBlank === false) {
            const flag = this.state.toggle
            if (!flag) {
                this.setState({ activeTab: activeTab });
                if (this.props.dispatchTabChange) {
                    if (this.props.handleNextButton) {
                        this.props.handleNextButton(activeTab)
                    }
                    this.props.dispatchTabChange(activeTab)
                }
            } else {
                this.setState({ activeTabCopy: activeTab }, this.showModal("terms"));
            }
        }
    };

    render() {
        const { classes } = this.props;
        const { activeTab } = this.state;
        const _state = this.props.spendDetails;
        const nextTab = [{ menuId: 1, nextMenuId: 5 }, { menuId: 2, nextMenuId: 3 }, { menuId: 3, nextMenuId: 7 }, { menuId: 4, nextMenuId: 11 }, { menuId: 5, nextMenuId: 4 }, { menuId: 6, nextMenuId: 2 }, { menuId: 7, nextMenuId: 8 }, { menuId: 8, nextMenuId: 10 }, { menuId: 10, nextMenuId: 1 }, { menuId: 11, nextMenuId: 6 }, { menuId: 12, nextMenuId: 6 }]
        const nextTabSCC = [{ menuId: 1, nextMenuId: 5 }, { menuId: 2, nextMenuId: 3 }, { menuId: 3, nextMenuId: 7 }, { menuId: 4, nextMenuId: 11 }, { menuId: 5, nextMenuId: 4 }, { menuId: 6, nextMenuId: 2 }, { menuId: 7, nextMenuId: 8 }, { menuId: 8, nextMenuId: 10 }, { menuId: 10, nextMenuId: 1 }, { menuId: 11, nextMenuId: 6 }, { menuId: 12, nextMenuId: 6 }]

        const tabOrder = [1, 5, 9, 4, 11, 12, 6, 2, 3, 7, 8, 10]

        var c = tabOrder.reduce(function (r, a, i) {
            r[a] = i;
            return r;
        }, {});

        // Build a cloned, filtered and sorted tabs array to avoid mutating props
        let visibleTabs = Array.isArray(this.props.tabs) ? [...this.props.tabs] : [];

        // If prop explicitly says 'No' hide the "Saving" tab
        if (this.props.isSavingTabVisible === 'No') {
            visibleTabs = visibleTabs.filter(tab => (tab.label || '').toLowerCase() !== 'saving');
        }

        visibleTabs.sort(function (x, y) {
            return (c[x.id] || 0) - (c[y.id] || 0);
        });

        return (
            <div className="tab-container bottom-space">
                <div className="grid-x">
                    <div className="medium-12 large-12">
                        <AppBar position="static" className={classes.root}>
                            <Tabs
                                value={activeTab}
                                onChange={this.handleChange}
                                classes={{ indicator: classes.indicator }}
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                {
                                    visibleTabs.map((tab, i) => {
                                        //var disabledTab = _state && _state.isLoading && activeTab === tab.id ? false : (_state && _state.isLoading);
                                        var disabledTab = _state && _state.isLoading
                                        return (<Tab
                                            classes={{ label: classes.textColor }}
                                            id={tab.id}
                                            key={tab.id}
                                            label={tab.label}
                                            value={tab.id}
                                            className={'tabs-header'}
                                            aria-controls={`wrapped-tabpanel-${i}`}
                                            disabled={disabledTab}
                                        />)
                                    })
                                }
                            </Tabs>
                        </AppBar>
                        {
                            visibleTabs.map(tab => (
                                activeTab === tab.id
                                    ? <TabContainer classStyle={classes.paddingTop} key={tab.id}>{tab.component}</TabContainer>
                                    : null
                            ))
                        }
                    </div>
                </div>
                {
                    this.props.isLastSubTab && !this.props.isGeneratePresentationClicked ?
                        (
                            <div className="grid-x">
                                <div className="medium-12 cell float-right" style={{ visibility: this.props.btnDisabled ? 'hidden' : 'visible' }}>
                                    <button className="floating-btn" float
                                        disabled={this.props.spendDetails !== undefined ? this.props.spendDetails.isLoading : false}
                                        onClick={(event) => {
                                            var index = 0
                                            for (; index < visibleTabs.length; index++) {
                                                if (activeTab === visibleTabs[index].id) {
                                                    break;
                                                }
                                            }
                                            var nextMenuId = this.props.spendDetails && this.props.spendDetails.solutionScope == 'Supply Chain Collaboration' ? nextTabSCC.filter(i => i.menuId == this.props.tabMenu)[0].nextMenuId : nextTab.filter(i => i.menuId == this.props.tabMenu)[0].nextMenuId;
                                            this.handleChange(event, nextMenuId);
                                        }
                                        }
                                    > Next </button>
                                </div>
                            </div>
                        ) : null
                }
                <div>
                    <Modal
                        ref="terms"
                        modalStyle={changeModalStyle}
                        contentStyle={changeModalContentStyle}
                    >
                        <div className="grid-x grid-padding-x change-popup">
                            <div className="medium-12">
                                <button onClick={() => this.hideModal("terms")} className="close" />
                            </div>
                            <div className="medium-12 pt30">
                                {this.props.tabMessage.toggleTabMessage}
                            </div>
                            <div className="medium-12 popupOkBtn">
                                <div className="float-right mt5">
                                    <div className="float-left"><Button
                                        content={"Continue without saving changes"}
                                        onClick={() => this.closeModal("terms")}
                                        color /></div>
                                    <div className="float-left"><Button
                                        content={"Cancel to return to current page"}
                                        onClick={() => this.hideModal("terms")}
                                        color /></div>
                                </div>
                            </div>
                        </div>

                    </Modal>
                </div>
                <div>
                    <Modal
                        ref="KPI"
                        modalStyle={alertModalStyle}
                        contentStyle={changeModalContentStyle}
                    >
                        <div className="grid-x grid-padding-x change-popup">
                            <div className="medium-12">
                                <button onClick={() => this.hideModal("KPI")} className="close" />
                            </div>
                            <div className="medium-12 pt30">
                                {this.props.tabMessage.toggleKPITabMessage}
                            </div>
                            <div className="grid-x medium-12 mt20">
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleKPITabYesButton}
                                        onClick={() => this.continueKPINavigation("KPI", false)}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleKPITabNoButton}
                                        onClick={() => this.hideModal("KPI")}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleKPITabRevertButton}
                                        onClick={() => this.continueKPINavigation("KPI", true)}
                                        color />
                                </div>
                            </div>
                        </div>

                    </Modal>
                </div>
                <div>
                    <Modal
                        ref="VS"
                        modalStyle={alertModalStyle}
                        contentStyle={changeModalContentStyle}
                    >
                        <div className="grid-x grid-padding-x change-popup">
                            <div className="medium-12">
                                <button onClick={() => this.hideModal("VS")} className="close" />
                            </div>
                            {this.props.user.error ? (
                                <div className="errors" dangerouslySetInnerHTML={{
                                    __html: (() => {
                                        const error = this.props.user.error;

                                        var replaced = '';
                                        replaced = error.replace(/\\n/g, "<br />")

                                        return replaced;
                                    })()
                                }} />
                            ) : null}
                            <div className="medium-12 pt30">
                                {this.props.tabMessage.toggleVSMessage}
                            </div>
                            <div className="grid-x medium-12 mt20">
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSYesButton}
                                        onClick={() => this.continueValueStoryNavigation("VS")}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSNoButton}
                                        onClick={() => this.continueNavigation("VS")}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSRevertButton}
                                        onClick={() => this.hideModal("VS")}
                                        color />
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div>
                    <Modal
                        ref="SpendParameter"
                        modalStyle={alertModalStyleSpendParameter}
                        contentStyle={changeModalContentStyle}
                    >
                        <div className="grid-x grid-padding-x change-popup">
                            <div className="medium-12">
                                <button onClick={() => this.hideModal("SpendParameter")} className="close" />
                            </div>
                            <div className="medium-12 pt30">
                                {this.props.tabMessage.toggleVSMessage}
                            </div>
                            <div className="grid-x medium-12 mt20">
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleSpendParamYesButtonWithStrategy}
                                        onClick={() => this.continueSpendParameterNavigationWithWaveRecalc("SpendParameter")}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleSpendParamYesButton}
                                        onClick={() => this.continueSpendParameterNavigation("SpendParameter")}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSNoButton}
                                        onClick={() => this.continueNavigation("SpendParameter")}
                                        color />
                                </div>
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSRevertButton}
                                        onClick={() => this.hideModal("SpendParameter")}
                                        color />
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

SpendTabPanel.propTypes = {
    classes: PropTypes.object.isRequired,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
            component: PropTypes.object.isRequired,
        }).isRequired)
        .isRequired,
};

const mapStateToProps = state => {
    return {
        change: state.detailedFileChanges.changes,
        tabMessage: state.content.spendAnalysis.detailedFile,
        subTabMenu: state.setSubTabMenu,
        tabMenu: state.setTabMenu,
        spendDetails: state.spendDetails,
        valueStory: state.valueStory,
        isLastSubTab: state.setIsLastSubTab,
        isGeneratePresentationClicked: state.isGeneratePresentationClicked,
        user: state.default,
        isSavingTabVisible: state.spendDetails && typeof state.spendDetails.isSavingTabVisible !== 'undefined' ? state.spendDetails.isSavingTabVisible : 'Yes'
    }
}

const mapDispatchToProps = dispatch => {
    return {
        pendingChanges: changes => dispatch(pendingChanges(changes)),
        saveKPIOnRedirect: changes => dispatch(saveKPIOnRedirect(changes)),
        deleteIntermediateKPIOnRedirect: changes => dispatch(deleteIntermediateKPIOnRedirect(changes)),
        isEnablementStrategyContainerPage: obj => dispatch(isEnablementStrategyContainerPage(obj)),
        setSubTabMenu: (val) => dispatch(setSubTabMenu(val)),
        setTabMenu: (val) => dispatch(setTabMenu(val)),
        saveValueStoryOnRedirect: changes => dispatch(saveValueStoryOnRedirect(changes)),
        isValueStoryPage: (obj) => dispatch(isValueStoryPage(obj)),
        isSpendParameterPage: obj => dispatch(isSpendParameterPage(obj)),
        saveSpendParametersOnRedirect: changes => dispatch(saveSpendParametersOnRedirect(changes)),
        setIsLastSubTab: (val) => dispatch(setIsLastSubTab(val)),
        isWaveRecalcOnSpendParamRedirect: changes => dispatch(isWaveRecalcOnSpendParamRedirect(changes)),
        // action to update saving tab visibility if needed
        // isSavingTabVisible: (obj) => dispatch(isSavingTabVisible(obj)),
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SpendTabPanel));
